import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ActionCardRootProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const RootComponent: React.FC<ActionCardRootProps> = ({
  children,
  className,
  style,
  onClick,
}) => {
  return (
    <button className={className} style={style} onClick={onClick}>
      {children}
    </button>
  );
};

export const Root: React.FC<ActionCardRootProps> = (
  props: ActionCardRootProps
) => {
  const Component = useCustomComponent({
    componentName: 'ActionCardRoot',
    Component: RootComponent,
  });

  return <Component {...props} />;
};
